// 物流资源模拟数据
export const logisticsResources = [
  {
    id: 1,
    type: '海运拼柜',
    ports: ['广州', '深圳'],
    clientTypes: ['批发市场商户', '无进项贸易公司'],
    supports1039: true,
    description: '适合多品类小批量出口，成本经济'
  },
  {
    id: 2,
    type: '海运整柜',
    ports: ['广州', '深圳'],
    clientTypes: ['境外采购代理', '外贸供应链'],
    supports1039: true,
    description: '适合大批量单一货源，时效稳定'
  },
  {
    id: 3,
    type: '空运',
    ports: ['广州', '深圳'],
    clientTypes: ['跨境电商', '高时效要求客户'],
    supports1039: true,
    description: '适合高价值货物，时效要求高'
  },
  {
    id: 4,
    type: '高频小批量出口',
    ports: ['广州'],
    clientTypes: ['跨境电商本土店', '小批量贸易商'],
    supports1039: true,
    description: '适合频繁发货，批次管理规范'
  }
];

// 仓储资源模拟数据
export const storageResources = [
  {
    id: 1,
    type: '市场集货仓',
    location: '广州白云',
    capabilities: ['支持多主体货权', '支持无进项货物', '可配合1039报关', '可出具规范出仓记录'],
    description: '专为批发市场商户设计，支持多供应商集货'
  },
  {
    id: 2,
    type: '中转仓/前置仓',
    location: '广州花都',
    capabilities: ['支持多主体货权', '支持无进项货物', '可配合1039报关', '可出具规范出仓记录'],
    description: '灵活中转存储，适合跨境电商预备货'
  },
  {
    id: 3,
    type: '报关协同仓',
    location: '广州南沙',
    capabilities: ['支持多主体货权', '支持无进项货物', '可配合1039报关', '可出具规范出仓记录'],
    description: '与报关行深度协同，合规操作标准化'
  }
];

// 客户类型与资源匹配
export const clientResourceMapping = [
  {
    clientType: '批发市场商户',
    recommendedLogistics: '拼柜',
    recommendedStorage: '市场集货仓',
    reason: '多品类小批量，成本敏感'
  },
  {
    clientType: '跨境电商本土店',
    recommendedLogistics: '空运/高频出口',
    recommendedStorage: '前置仓',
    reason: '时效要求高，备货灵活'
  },
  {
    clientType: '无进项贸易公司',
    recommendedLogistics: '拼柜',
    recommendedStorage: '合规中转仓',
    reason: '合规要求高，成本控制严格'
  },
  {
    clientType: '境外采购商指定代理',
    recommendedLogistics: '整柜',
    recommendedStorage: '指定收货仓',
    reason: '批量稳定，责任边界清晰'
  }
];